// 包装的组件出口
import Render from './render'
import { validate } from './utils'

export default Render

export {
  validate
}
